import { render } from "./Sale_Orders.vue?vue&type=template&id=006e508e&scoped=true"
import script from "./Sale_Orders.vue?vue&type=script&lang=js"
export * from "./Sale_Orders.vue?vue&type=script&lang=js"

import "./Sale_Orders.vue?vue&type=style&index=0&id=006e508e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006e508e"]])

export default __exports__